import router from '../router';
import { mapActions, mapGetters, mapState } from 'vuex';
import { rebindFormValidation } from '../utils';

export default {
    name: 'InitialForm',
    template: '#initial-form-template',
    data() {
        return {
            permitNumber: this.$store.state.permitNumber,
            permitYear: this.$store.state.permitYear
        };
    },
    created() {
        this.$store.dispatch('setPerformingInitialLoad', false);
        this.getPermitYears()
            .then(() => {
                $('#initial-form .years-select').focus();

                if (!this.permitYear) {
                    //[this.permitYear] = this.permitYears.slice(-1);
                    this.permitYear = this.permitYears;
                }
            });
    },
    updated() {
        rebindFormValidation();
    },
    computed: {
        ...mapState([
            'permitYears',
            'permitYearsLoading'
        ]),
        ...mapGetters([
            'getPermitYear'
        ]),
        pendingAsyncRequest() {
            return this.$store.state.pendingAsyncRequest;
        }
    },
    methods: {
        ...mapActions([
            'getPermitYears'
        ]),
        yearSelectChange(event) {
            $('#initial-form #LASNumber').focus();
        },
        submitInitialForm() {
            if ($('#initial-form').valid()) {
                router.push(`/${this.permitNumber}/${this.permitYear}`);
            }
        }
    }
};